export const isLimitUpdateOlderThanYear = limits => {
  let oldestTime = Infinity;

  limits.forEach(limit => {
    if (limit.updateTime) {
      oldestTime = Math.min(oldestTime, limit.updateTime);
    }
  });

  if (oldestTime === Infinity) return true;

  const YEAR = 365 * 24 * 60 * 60 * 1000;
  return Date.now() - oldestTime >= YEAR;
};

export const isSelfRegulationOlderThanYear = data => {
  if (data.period === 'NEVER' || !data.updateTime) return true;

  const YEAR = 365 * 24 * 60 * 60 * 1000;
  return Date.now() - data.updateTime >= YEAR;
};
